import React from 'react';
import Edit from '../../../containers/rest/Edit';
import Form from '../components/Form';

const DealersEdit = props => (
  <Edit {...props} resource="dealers">
    <Form />
  </Edit>
);

DealersEdit.propTypes = {};

export default DealersEdit;
